module.exports = __webpack_public_path__ + "img/glodal_variable.cfe18681.svg";